const handleImg = (url, x, y) => {
    const size = Math.round(Math.max(x, y) * 1.5)
    return `${url}?x-oss-process=image/resize,w_${size},h_${(size)}`
}
export const handleFeed = (item) => {
    const { content_type: type, building } = item
    item.house_link = building ? `/pages/building/main?building_id=${building.id}` : ''
    if (type === 'blog') {
        if (item.content_body.text.length > 135) {
            item.content_body.fold_text = item.content_body.text.substring(0, 135) + '...'
            item.fold = true
            item.show_fold = true
        }
        if (item.author) {
            item.author.name = item.author.name.replace('置业顾问', '').replace(/【.*】/, '')
        }
    }
    const photos = item.content_body.photos || []
    if (photos.length === 1) {
        item.content_body.photos_little = photos.map((photo) => {
            return handleImg(photo, 686, 240)
        })
    } else if (photos.length === 2) {
        item.content_body.photos_little = photos.map((photo) => {
            return handleImg(photo, 328, 240)
        })
    } else {
        item.content_body.photos_little = photos.map((photo, i) => {
            if (i === 0) {
                return handleImg(photo, 440, 464)
            }
            return handleImg(photo, 224, 224)
        })
    }
    item.can_comment = item.content_type !== 'comment' && item.content_type !== 'weixin_article'
    return item
}
export const mapBlogs = (items, building_id, keyword) => {
    return items.map(item => {
        const photos_urls = item.photos_urls || []
        item.house_link = building_id ? `/pages/building/main?building_id=${building_id}` : ''
        if (item.content.length > 135) {
            item.fold_text = item.content.substring(0, 135) + '...'
            item.fold = true
            item.show_fold = true
        }
        if (item.author_details) {
            item.author_details.name = item.author_details.name?.replace('置业顾问', '')?.replace(/【.*】/, '')
        }
        if (photos_urls.length === 1) {
            item.photos_little = photos_urls.map((photo) => {
                return handleImg(photo, 686, 240)
            })
        } else if (photos_urls.length === 2) {
            item.photos_little = photos_urls.map((photo) => {
                return handleImg(photo, 328, 240)
            })
        } else {
            item.photos_little = photos_urls.map((photo, i) => {
                if (i === 0) {
                    return handleImg(photo, 440, 464)
                }
                return handleImg(photo, 224, 224)
            })
        }
        if (keyword) {
            let  replaceReg =  new  RegExp( keyword,  'g' )
            let  replaceString =  '<span style="color:#00B08D">'  +  keyword +  '</span>'
            item.content=item.content.replace(replaceReg, replaceString);
        }
        return item
    })
}
export const mapFeeds = (items = []) => {
    return items.map(handleFeed)
}
